import { render } from "./AnnouncementCard.vue?vue&type=template&id=5f9c5526&scoped=true"
import script from "./AnnouncementCard.vue?vue&type=script&lang=js"
export * from "./AnnouncementCard.vue?vue&type=script&lang=js"

import "./AnnouncementCard.vue?vue&type=style&index=0&id=5f9c5526&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f9c5526"]])

export default __exports__